import { useState, useEffect } from 'react'
import { AnimatePresence, motion } from 'motion/react'

interface AnimatedPlaceholderProps {
  hints: string[]
  intervalMs?: number
  visible?: boolean
}

export function AnimatedPlaceholder({
  hints,
  intervalMs = 3500,
  visible = true,
}: AnimatedPlaceholderProps) {
  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    if (!visible || hints.length <= 1) return

    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % hints.length)
    }, intervalMs)

    return () => clearInterval(timer)
  }, [visible, hints.length, intervalMs])

  return (
    <AnimatePresence mode="wait">
      {visible && (
        <motion.span
          key={currentIndex}
          initial={{ opacity: 0, y: 4 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -4 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
          className="pointer-events-none absolute inset-0 flex items-start px-3 pt-2 text-sm text-muted-foreground/60 select-none"
        >
          {hints[currentIndex]}
        </motion.span>
      )}
    </AnimatePresence>
  )
}
